module.exports = __webpack_public_path__ + "public/img/bahasa-inggris-untuk-legal-belakang.23f6db3f.png";